import React, { useState } from 'react';
import TopNav from '../components/TopNav';
import ComposeModal from '../components/ComposeModal';
import Footer from '../components/Footer';
import { postsAPI } from '../api';
import './ReportBuilder.css';

const ReportBuilder = () => {
  const [isComposeModalOpen, setIsComposeModalOpen] = useState(false);

  const handleComposeClick = () => {
    setIsComposeModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsComposeModalOpen(false);
  };

  const handleSubmitPost = async (postData, postId = null) => {
    try {
      if (postId) {
        await postsAPI.update(postId, postData);
      } else {
        await postsAPI.create(postData);
      }
    } catch (error) {
      console.error('Error saving post:', error);
      throw error;
    }
  };
  return (
    <div className="report-builder-page">
      <TopNav activePage="report-builder" onComposeClick={handleComposeClick} />

      <main className="report-builder-container">
        <h1>Report Builder</h1>
        <p className="subtitle">Create custom analytics reports</p>
        
        <div className="content-placeholder">
          <p>Report builder features coming soon...</p>
        </div>
      </main>

      <ComposeModal 
        isOpen={isComposeModalOpen}
        onClose={handleCloseModal}
        onSubmit={handleSubmitPost}
      />
      <Footer />
    </div>
  );
};

export default ReportBuilder;
